export default __webpack_public_path__ + "static/media/19_footer_stock.8e622159.png";